export function toDateInput(value: unknown): string {
  const fallback = new Date().toISOString().slice(0, 10);
  if (!(value instanceof Date) && typeof value !== "string") return fallback;

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime())
    ? fallback
    : date.toISOString().slice(0, 10);
}
